<script setup>
import { computed } from 'vue'
const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  rows: { type: Number, default: 4 },
  error: { type: String, default: '' },
  hint: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  id: { type: String, default: '' },
})
defineEmits(['update:modelValue'])
const hasError = computed(() => !!props.error)
</script>

<template>
  <div class="flex flex-col gap-1">
    <textarea
      :id="id"
      :value="modelValue"
      :placeholder="placeholder"
      :rows="rows"
      :disabled="disabled"
      :aria-invalid="hasError || undefined"
      :aria-describedby="hasError ? `${id}-err` : undefined"
      :class="[
        'w-full px-3 py-2 text-sm bg-[color:var(--surface)] text-[color:var(--ink)]',
        'rounded-[var(--radius-input)] border transition-colors resize-y',
        'focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--accent)]',
        hasError ? 'border-[color:var(--danger)]' : 'border-[color:var(--line)] focus:border-[color:var(--accent)]',
        disabled && 'opacity-50 cursor-not-allowed',
      ]"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <p v-if="hasError" :id="`${id}-err`" class="text-xs text-[color:var(--danger)]">{{ error }}</p>
    <p v-else-if="hint" class="text-xs text-[color:var(--muted)]">{{ hint }}</p>
  </div>
</template>
